module.exports = {"first_name":"Vorname","enter_first_name":"Vornamen eingeben"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/de/firstName.json
// module id = 485
// module chunks = 248 1693